import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EmonPriceProvider } from "@/contexts/EmonPriceContext";
import { FloatingBackButton } from "@/components/FloatingBackButton";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Support from "./pages/Support";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AntiFraud from "./pages/AntiFraud";
import Marketplace from "./pages/Marketplace";
import Admin from "./pages/Admin";
import Analytics from "./pages/Analytics";
import Emon from "./pages/Emon";
import NftInfo from "./pages/NftInfo";

import PublicProfile from "./pages/PublicProfile";
import EarlyCreators from "./pages/EarlyCreators";
import Leaderboard from "./pages/Leaderboard";
import NftPage from "./pages/Nft";
import ShareNftRedirect from "./pages/ShareNftRedirect";
import HowItWorks from "./pages/HowItWorks";
import XShareBounce from "./pages/XShareBounce";
import AirdropChallenge from "./pages/AirdropChallenge";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <EmonPriceProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          
          <BrowserRouter>
            <FloatingBackButton />
            <Routes>
              <Route path="/" element={<Index />} />
              
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/support" element={<Support />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/anti-fraud" element={<AntiFraud />} />
              <Route path="/profile/:identifier" element={<PublicProfile />} />
              <Route path="/nft/:id" element={<NftPage />} />
              <Route path="/share/nft/:id" element={<ShareNftRedirect />} />
              <Route path="/early-creators" element={<EarlyCreators />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/x-share-bounce" element={<XShareBounce />} />
              <Route path="/emon" element={<Emon />} />
              <Route path="/nft-info" element={<NftInfo />} />
              <Route path="/airdrop-challenge" element={<AirdropChallenge />} />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </EmonPriceProvider>
    </QueryClientProvider>
  );
}
